import { render } from "./sipClient.vue?vue&type=template&id=2e894cac&scoped=true"
import script from "./sipClient.vue?vue&type=script&lang=js"
export * from "./sipClient.vue?vue&type=script&lang=js"

import "./sipClient.vue?vue&type=style&index=0&id=2e894cac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e894cac"]])

export default __exports__